import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { Logo } from "@/components/Nav";
import { api, formatApiError } from "@/lib/api";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => document.head.removeChild(m);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("nexreq_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err, "Invalid email or password"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-obsidian px-6" data-testid="admin-login-page">
      <Seo title="Admin Login — NEXREQ" siteName="NEXREQ" description="NEXREQ administration." />
      <div className="w-full max-w-md">
        <div className="flex justify-center">
          <Logo className="h-20 sm:h-24" />
        </div>
        <form onSubmit={submit} className="mt-10 border border-white/10 bg-surface p-8 lg:p-10" data-testid="admin-login-form">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-emerald-500">Administration</p>
          <h1 className="mt-3 font-heading text-2xl font-light text-white">Sign In</h1>
          <div className="mt-7 space-y-5">
            <div>
              <label className="nx-label" htmlFor="admin-email">Email</label>
              <input
                id="admin-email"
                type="email"
                className="nx-input"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email-input"
              />
            </div>
            <div>
              <label className="nx-label" htmlFor="admin-password">Password</label>
              <input
                id="admin-password"
                type="password"
                className="nx-input"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input"
              />
            </div>
            {error && (
              <p className="border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300" data-testid="admin-login-error">
                {error}
              </p>
            )}
            <button type="submit" className="nx-btn-primary w-full" disabled={loading} data-testid="admin-login-submit-btn">
              {loading ? "Signing in…" : "Sign In"} <ArrowRight size={15} />
            </button>
          </div>
        </form>
        <p className="mt-6 text-center text-xs text-white/30">
          <Link to="/" className="transition-colors hover:text-emerald-400" data-testid="admin-login-back-link">
            ← Back to nexreq.ae
          </Link>
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
